import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'

@Component({
	selector: 'course-lock',
	templateUrl: './course-lock.component.html',
	styleUrls: ['./course-lock.component.scss']
})

export class CourseLockComponent implements OnInit, OnDestroy {

	@Input() course = 0
	@Input() locked = false
	finalWarning = false

	locking = false
	lockSuccess = false
	lockError = false
	unlocking = false
	unlockSuccess = false
	unlockError = false

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	lockSub = new Subscription
	unlockSub = new Subscription

	constructor(private dataService: ApiService) {}

	ngOnInit() {}

	ngOnDestroy() {
		this.lockSub?.unsubscribe()
		this.unlockSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	lock() {
		if (!this.finalWarning) {
			this.finalWarning = true
			return
		}

		this.unlocking = false
		this.unlockSuccess = false
		this.unlockError = false
		this.locking = true
		this.lockSuccess = false
		this.lockError = false

		this.lockSub = this.dataService.courseLock(this.course)
		.subscribe(
			data => {
				console.log(data)

				this.lockSuccess = true
				this.locking = false
				this.lockError = false

				setTimeout(() => {
					window.location.reload()
				}, 2000)
			},
			error => {
				console.log(error)

				this.lockError = true
				this.locking = false
				this.lockSuccess = false
			},
		)
	}

	unlock() {
		this.locking = false
		this.lockSuccess = false
		this.lockError = false
		this.unlocking = true
		this.unlockSuccess = false
		this.unlockError = false

		this.unlockSub = this.dataService.courseUnlock(this.course)
		.subscribe(
			data => {
				console.log(data)

				this.unlockSuccess = true
				this.unlocking = false
				this.unlockError = false

				setTimeout(() => {
					window.location.reload()
				}, 2000)
			},
			error => {
				console.log(error)

				this.unlockError = true
				this.unlocking = false
				this.unlockSuccess = false
			},
		)
	}

}
